const notifications = {
	title: "Varslinger",
	new_notification: "Ny varsling",
	edit_notification: "Endre {name}",
	view_notification: "Vis {name}",
	list_title: "Varslinger",
	create_title: "Opprett varsling",
	update_title: "Endre varsling",
	site: "Klient",
	header: "Tittel",
	body: "Innhold",
	start_date: "Start dato",
	start_time: "Start tid",
	end_date: "Slutt dato",
	end_time: "Slutt tid",
	trigger: "Trigger",
	type: "Type",
	status: "Status",
};
export default notifications;